/**
 * Presentation-local orange toggle. Native checkbox semantics underneath.
 * Prop-driven only — no Redux/auth/routing.
 */
function PresentationToggle({
  id,
  checked = false,
  disabled = false,
  onChange,
  label,
  help,
  error,
  "data-testid": testId,
}) {
  const helpId = help ? `${id}-help` : undefined;
  const errorId = error ? `${id}-error` : undefined;
  const describedBy = [helpId, errorId].filter(Boolean).join(" ") || undefined;

  return (
    <div
      className={[
        "presentation-toggle",
        disabled ? "presentation-toggle--disabled" : "",
        error ? "presentation-toggle--invalid" : "",
      ]
        .filter(Boolean)
        .join(" ")}
      data-testid={testId || "presentation-toggle"}
    >
      <label className="presentation-toggle__row" htmlFor={id}>
        <span className="presentation-toggle__control">
          <input
            id={id}
            type="checkbox"
            className="presentation-toggle__input"
            checked={Boolean(checked)}
            disabled={disabled}
            aria-describedby={describedBy}
            aria-invalid={error ? "true" : undefined}
            onChange={(event) => onChange?.(event.target.checked, event)}
          />
          <span className="presentation-toggle__track" aria-hidden="true">
            <span className="presentation-toggle__thumb" />
          </span>
        </span>
        <span className="presentation-toggle__copy">
          <span className="presentation-toggle__label">{label}</span>
          {help ? (
            <span id={helpId} className="presentation-toggle__help">
              {help}
            </span>
          ) : null}
        </span>
      </label>
      {error ? (
        <p id={errorId} className="presentation-form__error" role="alert">
          {error}
        </p>
      ) : null}
    </div>
  );
}

export default PresentationToggle;
